/**
 * DS-internal hook : faut-il montrer le squelette de la page, maintenant ?
 *
 * La règle vit dans `utils/skeletonGate` (pure, testée) ; le crochet n'y ajoute que le minuteur
 * du seuil. Rend `true` seulement quand la page charge ET que le seuil est passé — une réponse
 * rapide n'a donc jamais de squelette, et la page reste vide le temps du seuil.
 */
import { useEffect, useReducer } from "react"

import { initialSkeletonGate, nextSkeletonGate, SKELETON_APPEAR_DELAY_MS } from "../utils/skeletonGate"

export function useSkeletonGate(loading: boolean): boolean {
    const [gate, dispatch] = useReducer(nextSkeletonGate, loading, initialSkeletonGate)

    useEffect(() => {
        dispatch(loading ? "loading" : "loaded")
    }, [loading])

    useEffect(() => {
        if (gate !== "waiting") return
        const timer = setTimeout(() => dispatch("elapsed"), SKELETON_APPEAR_DELAY_MS)
        return () => clearTimeout(timer)
    }, [gate])

    return loading && gate === "shown"
}
